import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { APP_LINKS } from '@/helpers/links';
import { LoanTermsFpgVersion01 } from './versions/v1';
import { FPG_PLANS as PLANS_V1 } from './versions/v1/constants';

const VERSIONS = ['v1'];

const VERSION_PLANS = {
  v1: Object.values(PLANS_V1),
};

const LoanTermsFpgPage = () => {
  const { version } = useParams();
  const [searchParams] = useSearchParams();
  const plan = searchParams.get('plan');
  const resolvedVersion = version || 'v1';

  if (version && !VERSIONS.includes(version)) {
    return <Navigate to={APP_LINKS.loanTermsFpg()} replace />;
  }

  const allowedPlans = VERSION_PLANS[resolvedVersion];
  if (plan && allowedPlans && !allowedPlans.includes(plan)) {
    return <Navigate to={APP_LINKS.loanTermsFpg()} replace />;
  }

  switch (version) {
    case 'v1':
    default:
      return <LoanTermsFpgVersion01 />;
  }
};

export default LoanTermsFpgPage;